import React, {  Component } from 'react';
import { connect } from 'react-redux';
import {browserHistory} from 'react-router';

class createPriceTagRedirectDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        };
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
    }

    handleContinue(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.fireGTMTag('Header Create Price Tags');
        browserHistory.push("/list");
    }

	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: true
        });
	}

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <h2 className="title">CREATE PRICE TAGS</h2>
                    <p>You are being directed to your <b>List</b> page where you can create a price tag. If you don’t have any products in your List, please add products to your List first before creating a price tag.</p>
                    <div className="noButtonContainer">
						<a className="noButton blueButton" onClick={this.closeDialog.bind(this)} href="">Cancel</a>
                    </div>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={this.handleContinue.bind(this)} href="">Continue</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

createPriceTagRedirectDialog = connect(mapStateToProps)(createPriceTagRedirectDialog);
export default createPriceTagRedirectDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/createPriceTagRedirectDialog.js